import { render, staticRenderFns } from "./PartitionPage.vue?vue&type=template&id=17228d1e&"
import script from "./PartitionPage.vue?vue&type=script&lang=js&"
export * from "./PartitionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports